import DashboardLayout from '../layouts/DashboardLayout'
// import OrderList from '../pages/order/OrderList'
// import OrderDetail from '../pages/order/OrderDetail'
// import OrderListMobile from '../pages/order/OrderListMobile'
// import OrderCreateContact from '../pages/order/OrderCreateContact'
// import OrderAccountList from '../pages/order/OrderAccountList'
// import OrderAccountListMobile from "@/pages/order/OrderAccountListMobile";

export const orderMenu = {
  path: '/orders',
  component: DashboardLayout,
  name: 'Orders',
  redirect: '/orders/payment-hub',
  children: [
    {
      path: 'payment-hub',
      name: 'PaymentHub',
      component: () => import (/* webpackChunkName: "paymentHub" */'../pages/payment-hub/List.vue'),
      meta: {
        roles: 'all',
        requiresAuth: true,
        breadcrumb: [{
          title: 'Danh sách giao dịch',
        }]
      },
    },
  ],
}
